import React from 'react'
import Task from '../FinancialStory/advisor-components/task-components/Task';

const HHSearchTask = ({ taskData, query }) => {
  // For search context, we'll use basic query keys that make sense for search results
  const searchQueryKey = ['hh-search', taskData?.household_id];
  const tasksListQueryKey = `financial-story-task-list-${taskData?.household_id}`;
  const activeChaptersListQueryKey = `active-financial-story-chapters-list-${taskData?.household_id}`;
  const completedChaptersListQueryKey = `financial-story-completed-chapters-list-${taskData?.household_id}`;
  console.log('taskData', taskData)
  return (
    <div>
      {/* Display chapter name if available */}
      {taskData?.title && (
        <div className="mb-2 text-sm text-gray-600 bg-gray-50 px-2 py-1 rounded">
          <span className="font-medium">Chapter:</span> {taskData.title}
        </div>
      )}
      <Task
        task={taskData}
        additionalQueries={[searchQueryKey]}
        tasksListQueryKey={tasksListQueryKey}
        chaptersListQueryKey={activeChaptersListQueryKey}
        completedTasksListQueryKey={completedChaptersListQueryKey}
        isClientPortalTask={false}
        isTruncated={false}
        query={query}
      />
    </div>
  )
}

export default HHSearchTask